import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { ListStockItemsQuery } from '@/core/domain/stock/StockItems/StockItems.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { RegistrationsDefaultCode } from '@/types/Register';
import { Col, Input } from 'antd';
import { useIntl } from 'react-intl';

const ConfigurationFilterPart = ({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListStockItemsQuery>) => {
  const intl = useIntl().formatMessage;
  const { data } = useMatrix();

  const defaultPartCode = data?.matrixSettings.defaultPartCode;

  const typevalueCode = () => {
    if (defaultPartCode === RegistrationsDefaultCode.barCode)
      return queryParams?.barcode;
    if (defaultPartCode === RegistrationsDefaultCode.companyCode)
      return queryParams?.companyCode;
    if (defaultPartCode === RegistrationsDefaultCode.internalCode)
      return queryParams?.sku;
    if (defaultPartCode === RegistrationsDefaultCode.manufacturerCode)
      return queryParams?.manufacturingCode;
    return;
  };

  const typeplaceholderCode = () => {
    if (defaultPartCode === RegistrationsDefaultCode.barCode)
      return 'inventory.page.form.modal.fetchItems.table.barCode';
    if (defaultPartCode === RegistrationsDefaultCode.companyCode)
      return 'inventory.page.form.modal.fetchItems.table.companyCode';
    if (defaultPartCode === RegistrationsDefaultCode.internalCode)
      return 'inventory.page.form.modal.fetchItems.table.sku';
    if (defaultPartCode === RegistrationsDefaultCode.manufacturerCode)
      return 'inventory.page.form.modal.fetchItems.table.manufacturerCode';
    return;
  };

  return (
    <Col xs={24}>
      <Input
        value={typevalueCode()}
        onChange={({ target: { value } }) => {
          let type = {};

          if (defaultPartCode === RegistrationsDefaultCode.barCode)
            type = { barcode: value };
          if (defaultPartCode === RegistrationsDefaultCode.companyCode)
            type = { companyCode: value };
          if (defaultPartCode === RegistrationsDefaultCode.internalCode)
            type = { SKU: value };
          if (defaultPartCode === RegistrationsDefaultCode.manufacturerCode)
            type = { manufacturingCode: value };

          setQueryParams((prev) => ({ ...prev, ...type }));
        }}
        placeholder={intl({
          id: typeplaceholderCode(),
        })}
      />
    </Col>
  );
};

export default ConfigurationFilterPart;
